<!-- @if(!loadSpinner){ -->
<h1 class="page__heading !k-mb-4">IHMS Action Items</h1>
<div class="page__content">
    <kendo-grid scrollable="none" [kendoGridBinding]="gridView" [pageSize]="10" [pageable]="{
                pageSizes: [5, 10, 20],
            }" [columnMenu]="{filter:true, columnChooser:false, sort:true}" [loading]="ihmsService.loadingIhmsActions">
        <ng-template kendoGridToolbarTemplate position="top">
            <div class=toolbar-wrapper>
                <kendo-textbox placeholder="Search Student Name or ID" [style.width.px]="401"
                    (valueChange)="handleActionItemsSearch($event)">
                    <ng-template kendoTextBoxPrefixTemplate>
                        <kendo-svg-icon [icon]="searchIcon" size="medium" themeColor="primary"></kendo-svg-icon>
                    </ng-template>
                </kendo-textbox>
            </div>
        </ng-template>
        <kendo-grid-column field="Student">
            <ng-template kendoGridCellTemplate let-dataItem>
                <div class="primary-text k-cursor-pointer text-overflow" role="link" tabindex="0"
                    (click)="routeToStudentProfile(dataItem?.studentId)"
                    (keydown.enter)="routeToStudentProfile(dataItem?.studentId)"
                    (keydown.space)="routeToStudentProfile(dataItem?.studentId)">
                    {{ dataItem?.studentName }}
                </div>
                <p class="secondary-color k-m-0">{{dataItem?.studentId}}</p>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="District">
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem?.district }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="Unassigned Items">
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem?.unassignedItems }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="Open Items">
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem?.openItems }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="Parent/Guardian">
            <ng-template kendoGridCellTemplate let-dataItem>
                <p class="k-m-0">{{ dataItem.parentFirstName }} {{ dataItem.parentLastName }}</p>
                @if (dataItem?.parentPhone) {
                <span class="font-12 secondary-color">{{ dataItem?.parentPhone }}</span>
                }
                @if (dataItem?.parentEmail) {
                <span class="font-12 secondary-color"> | {{ dataItem?.parentEmail }}</span>
                }
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="CPSE Admin Name">
            <ng-template kendoGridCellTemplate let-dataItem>
                <p class="k-white-space-normal">{{ dataItem?.adminName }}</p>
            </ng-template>
        </kendo-grid-column>
        <ng-template kendoGridDetailTemplate let-dataItem let-rowIndex="rowIndex">
            <app-ihms-detail-action-items-grid [studentId]="dataItem?.studentId"
                [actionItems]="dataItem?.iHMSStudentResponses"
                [studentName]="dataItem?.studentName"></app-ihms-detail-action-items-grid>
        </ng-template>
    </kendo-grid>
</div>

<div kendoDialogContainer></div>